module.exports = __webpack_public_path__ + "img/about/80243-024.png";


//////////////////
// WEBPACK FOOTER
// ./img/about/80243-024.png
// module id = 21
// module chunks = 0